import { GenericAbortSignal } from "axios";
import { apiRequest, apiFormRequest } from "../configs/axios.config";

interface IPostRequest {
  url: string;
  data?: any;
  signal?: GenericAbortSignal;
}

const handleGlobalPostRequest = ({ url, data, signal }: IPostRequest) => {
  return apiRequest
    .post(url, data, { signal })
    .then((response) => response.data);
};
const handleGlobalFormPostRequest = ({ url, data }: IPostRequest) => {
  return apiFormRequest.post(url, data).then((response) => response.data);
};
const handleGlobalPatchRequest = ({ url, data }: IPostRequest) => {
  return apiRequest.patch(url, data).then((response) => response.data);
};

const handleGlobalPutRequest = ({ url, data }: IPostRequest) => {
  return apiRequest.put(url, data).then((response) => response.data);
};

const handleGlobalDeleteRequest = ({ url }: { url: string }) => {
  return apiRequest.delete(url).then((response) => response.data);
};

const handleGlobalPostFormRequest = ({ url, data }: IPostRequest) => {
  return apiFormRequest.post(url, data).then((response) => response.data);
};

export {
  handleGlobalFormPostRequest,
  handleGlobalDeleteRequest,
  handleGlobalPatchRequest,
  handleGlobalPostRequest,
  handleGlobalPutRequest,
  handleGlobalPostFormRequest,
};
